import { styled } from '@mui/material';
import { LoadingButton } from 'components';

export const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  height: theme.spacing(5),
  fontSize: 12,
  [theme.breakpoints.down('sm')]: {
    background: 'none',
    minWidth: 'initial',
    padding: 0,
    '.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));
